import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=0f632b60&scoped=true&"
import script from "./DashboardHome.vue?vue&type=script&lang=ts&"
export * from "./DashboardHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f632b60",
  null
  
)

export default component.exports